import { useThoughtSpotAPI } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { LiveboardsQueryKey } from "@/hooks/useLiveboards";
import { ThoughtspotLiveboard } from "@norma-bi/bi-api";

export function useFavoriteLiveboard() {
  const api = useThoughtSpotAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: { liveboardId: string; isFavorite: boolean }) => {
      if (args.isFavorite) {
        return api.unfavoriteThoughtspotLiveboard({ liveboard_id: args.liveboardId });
      }
      return api.favoriteThoughtspotLiveboard({ liveboard_id: args.liveboardId });
    },

    onMutate: async (args: { liveboardId: string; isFavorite: boolean }) => {
      await queryClient.cancelQueries({ queryKey: [LiveboardsQueryKey] });

      const previousLiveboards = queryClient.getQueryData<ThoughtspotLiveboard[]>([
        LiveboardsQueryKey,
      ]);

      queryClient.setQueryData<ThoughtspotLiveboard[]>([LiveboardsQueryKey], (old) => {
        if (!old) return old;

        return old.map((liveboard) =>
          liveboard.liveboard_id === args.liveboardId
            ? { ...liveboard, is_favorite: !args.isFavorite }
            : liveboard,
        );
      });

      return { previousLiveboards };
    },

    onError: (err, variables, context) => {
      if (context?.previousLiveboards) {
        queryClient.setQueryData([LiveboardsQueryKey], context.previousLiveboards);
      }
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [LiveboardsQueryKey] });
    },
  });
}
